import { Link } from 'react-router-dom';
import './App.css';

function NotFound() {
  return (
    <div className="not-found">
      <div className="not-found-content">
        <div className="not-found-number">404</div>
        <h1 className="not-found-title">Sayfa Bulunamadı</h1>
        <p className="not-found-description">
          Aradığınız sayfa mevcut değil veya taşınmış olabilir.
        </p>
        <div className="not-found-buttons">
          <Link to="/" className="btn btn-primary">
            Ana Sayfaya Dön
          </Link>
        </div>
      </div>
    </div>
  );
}

export default NotFound;

